import React from "react";
// Components
import { NotFound } from "../../components/shared";

const PageNotFound: React.FC = () => {
  return <NotFound message="PAGE NOT FOUND" />;
};

export default PageNotFound;
